<template>
  <div :class="{ top: popontop }">
    <div class="toolbarContainer">
      <div :id="`${id}toolbar`">
        <button class="ql-bold" tabindex="-1"></button>
        <button class="ql-italic" tabindex="-1"></button>
        <button class="ql-underline" tabindex="-1"></button>

        <select class="ql-color" title="Couleur du Texte" tabindex="-1">
          <option v-for="color in colors" :value="color" :key="color" />
        </select>
        <select class="ql-background" title="Couleur du Fond" tabindex="-1">
          <option v-for="color in colors" :value="color" :key="`bg${color}`" />
        </select>

        <button id="emoji-button" @click="showEmoji" tabindex="-1">
          &#128515;
        </button>
      </div>
      <VEmojiPicker v-if="emojis" :showSearch="false" class="emoji" @select="selectEmoji" />
    </div>

    <div :id="id" @dragend="false" />
  </div>
</template>
<script>
import Quill from "quill";
import { VEmojiPicker } from "v-emoji-picker";

export default {
  components: { VEmojiPicker },
  props: ["id", "prompt", "value", "popontop", "noendline"],

  methods: {
    refresh() {
      this.quill.setText("");
      this.quill.clipboard.dangerouslyPasteHTML(0, this.value);
    },

    clear() {
      this.quill.setText("");
      this.$emit("text-change", this);
    },

    selectEmoji(emoji) {
      var selection = this.quill.getSelection(true);
      this.quill.insertText(selection.index, emoji.data);
      this.emojis = false;
      this.$emit("text-change", this);
      this.$emit("input", this.quill.root.innerHTML);
    },

    showEmoji() {
      this.emojis = !this.emojis;
    }
  },
  data() {
    return {
      formats: ["bold", "fonts", "italic", "underline", "color", "background"],
      emojis: false,
      colors: [
        "#000000",
        "#e60000",
        "#ff9900",
        "#ffff00",
        "#008a00",
        "#0066cc",
        "#9933ff",
        "#ffffff",
        "#facccc",
        "#ffebcc",
        "#ffffcc",
        "#cce8cc",
        "#cce0f5",
        "#ebd6ff",
        "#bbbbbb",
        "#f06666",
        "#ffc266",
        "#ffff66",
        "#66b966",
        "#66a3e0",
        "#c285ff",
        "#888888",
        "#a10000",
        "#b26b00",
        "#b2b200",
        "#006100",
        "#0047b2",
        "#6b24b2",
        "#444444",
        "#5c0000",
        "#663d00",
        "#666600",
        "#003700",
        "#002966",
        "#3d1466"
      ],
      quill: null
    };
  },

  mounted() {
    let config = {
      theme: "snow",
      formats: this.formats,
      placeholder: this.prompt,
      modules: {
        toolbar: `#${this.id}toolbar`,
        keyboard: {
          bindings: {
            tab: {
              key: 9,
              handler: () => {
                this.$emit("focusout");
                return true;
              }
            },

            strike: {
              key: 13,
              handler: () => {
                this.$emit("enter");
                return this.noendline !== true;
              }
            }
          }
        }
      }
    };
    this.quill = new Quill(`#${this.id}`, config);

    // Disable on creation to prevent autofocus when the initial value is filled
    this.quill.enable(false);

    if (this.value) {
      this.quill.clipboard.dangerouslyPasteHTML(0, this.value);
    }
    this.quill.enable(true);

    this.quill.on("text-change", (delta, from, to) => {
      if (to != "api") {
        this.$emit("text-change", this, delta);
        this.$emit("input", this.quill.root.innerHTML);
      }
    });

    this.quill.on("selection-change", range => {
      if (range == null) {
        this.$emit("focusout");
      }
    });
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/css/quill.scss";

.emoji {
  position: absolute;
  top: 40px;
  left: 0px;
  z-index: 1000;
}

#emoji-button {
  font-size: 16px;
}

.toolbarContainer {
  position: relative;
}

.top {
  .emoji {
    position: absolute;
    bottom: 40px !important;
    left: 0 !important;
    top: unset !important;
  }
}
</style>
